module.exports = __webpack_public_path__ + "img/SAR.40ebf407.svg";